import React from 'react';
import omit from 'lodash/omit';

import { InContentModalWrapperProps } from './InContentModalWrapper.types';

const InContentModalWrapper = React.forwardRef<
  HTMLDivElement,
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > &
    InContentModalWrapperProps
>((props, ref) => {
  const { allowPropagation, ...divProps } = props;
  return (
    <div
      {...(allowPropagation ? omit(divProps, 'onClick') : divProps)}
      ref={ref}
    />
  );
});

InContentModalWrapper.displayName = 'InContentModalWrapper';

export default InContentModalWrapper;
